export class ServiceError {
    code: string
}

export enum ServiceErrorCodes {
    SERVICE_ERROR_CODE_UNKNOWN_ERROR = 'SERVICE_ERROR_CODE_UNKNOWN_ERROR'
}